import React from 'react';
import { Button, Form, Header, Input, Popup } from 'semantic-ui-react';
import { DateInput, STATUS_TYPES, TimeInput, Notification } from 'dyl-components';

import UsersForm from 'shared/forms/UsersForm';
import { DateTimeUtils } from 'dyl-components';
import selfReportActions from 'actions/self_report';

import './ActivityForm.scss';
import { connect } from 'react-redux';

const CallActivityForm = ({
    onChangeDate,
    date,
    onChangeTime,
    time,

    onChange,
    assigned_user,
    direction,
    result,
    numberOfHours,
    numberOfMinutes,
    note,
    onCancel,
    onAdd,
    size,
    isFuture,
    user_id,
    isLoggingCall,
    isCalendarOpen,
    onOpenCalendar,
    onCloseCalendar,
    isTimeInputOpen,
    onOpenTimeInput,
    onCloseTimeInput
}) => (
    <Form size={size} className='ActivityForm'>
        <Header as='h4' textAlign='center'>
            Call Activity
        </Header>
        <Form.Group widths='equal'>
            <Form.Field
                label='Assigned User'
                size={size}
            />
            <Form.Field
                user_id={user_id}
                control={UsersForm}
                user={assigned_user}
                name='assigned_user'
                onChange={onChange}
                size={size}
            />
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field
                label='Date'
                size={size}
                width={4}
            />
            <Popup
                trigger={<Form.Field
                    control={Input}
                    placeholder={`Set Date (${DateTimeUtils.DATE_FORMAT})`}
                    size={size}
                    onChange={onChangeDate}
                    value={date}
                    icon='calendar outline'
                />}
                content={(
                    <DateInput
                        onChange={onChangeDate}
                        minDate="01-01-1970"
                        value={date}
                        name='date'
                        inline
                    />
                )}
                on='click'
                open={isCalendarOpen}
                onOpen={onOpenCalendar}
                onClose={onCloseCalendar}
            />
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field
                label='Time'
                size={size}
                width={4}
            />
            <Popup
                trigger={<Form.Field
                    control={Input}
                    placeholder={`Set Time (${DateTimeUtils.TIME_FORMAT})`}
                    size={size}
                    onChange={onChangeTime}
                    value={time}
                    icon='clock'
                />}
                content={(
                    <TimeInput
                        onChange={onChangeTime}
                        value={time}
                        name='time'
                        inline
                    />
                )}
                on='click'
                open={isTimeInputOpen}
                onOpen={onOpenTimeInput}
                onClose={onCloseTimeInput}
            />
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field
                label='Call'
                size={size}
                width={4}
            />
            <Form.Select
                options={[
                    { key: 'outbound', value: 'outbound', text: 'Outbound' },
                    { key: 'inbound', value: 'inbound', text: 'Inbound' }
                ]}
                value={direction}
                onChange={onChange}
                fluid
                name='direction'
                size={size}
            />
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field
                label='Result'
                size={size}
                width={4}
            />
            <Form.Select
                options={[
                    { key: 'reached', value: 'reached', text: 'Reached' },
                    { key: 'not available', value: 'not available', text: 'Not Available' },
                    { key: 'missed', value: 'missed', text: 'Missed' },
                    { key: 'voicemail', value: 'voicemail', text: 'Voicemail' },
                    { key: 'do not call', value: 'do not call', text: 'Do not Call' },
                    ...(!isFuture ? [] : [{ key: 'upcoming', value: 'upcoming', text: 'Upcoming' }])
                ]}
                value={!isFuture ? result : 'upcoming'}
                onChange={onChange}
                name='result'
                fluid
                size={size}
                disabled={isFuture}
            />
        </Form.Group>
        <Form.Group
            widths='equal'
        >
            <Form.Field
                label='Length of Time'
                size={size}
            />
            <Form.Input
                type='number'
                min="0"
                value={numberOfHours}
                name='numberOfHours'
                placeholder='hh'
                step="1"
                onChange={onChange}
                size={size}
                width={13}
            />
            <Form.Input
                type='number'
                min="0"
                step="1"
                value={numberOfMinutes}
                name='numberOfMinutes'
                placeholder='mm'
                max="59"
                onChange={onChange}
                size={size}
                width={13}
            />
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field
                label="Note"
                size={size}
                width={4}
            />
            <Form.TextArea
                value={note}
                onChange={onChange}
                name="note"
                placeholder="Add Note"
                inline
                size={size}
            />
        </Form.Group>

        <div style={{ textAlign: 'right' }}>
            {!isLoggingCall && <Button size={size} onClick={onCancel}>Cancel</Button>}
            <Button size={size} loading={isLoggingCall} primary onClick={onAdd}>Add</Button>
        </div>
    </Form>
);

const initialState = {
    date: '',
    time: '',
    assigned_user: '',
    direction: 'outbound',
    result: 'reached',
    numberOfHours: '',
    numberOfMinutes: '',
    note: '',
    isCalendarOpen: false,
    isTimeInputOpen: false,

    isOpen: false
}

class CallActivityFormContainer extends React.Component {
    state = {
        ...initialState,
        assigned_user: this.props.assigned_user
    }

    onChange = (_, { name, value }) => {
        this.setState({ [name]: value });
    }

    onChangeDate = (_, { value }) => {
        this.setState({ date: value, isCalendarOpen: false });
    }

    onChangeTime = (_, { value }) => {
        this.setState({ time: value, isTimeInputOpen: false });
    }

    handleOpen = () => {
        this.setState({ isOpen: true });
    }

    onOpenCalendar = () => {
        this.setState({ isCalendarOpen: true });
    }

    onCloseCalendar = () => {
        this.setState({ isCalendarOpen: false });
    }

    onOpenTimeInput = () => {
        this.setState({ isTimeInputOpen: true });
    }

    onCloseTimeInput = () => {
        this.setState({ isTimeInputOpen: false });
    }

    handleClose = () => {
        const { isCalendarOpen, isTimeInputOpen } = this.state;
        if (isCalendarOpen || isTimeInputOpen) {
            return;
        }
        this.setState({ ...initialState, assigned_user: this.props.assigned_user });
    }

    onAdd = () => {
        const { direction, result, date, time, note: notes, assigned_user: user_id, numberOfHours: hh, numberOfMinutes: mm } = this.state;
        const { from, to, contact_id } = this.props;
        const length = DateTimeUtils.convertTimeToSeconds(`${hh}:${mm}`, 'HH:mm');
        const occurred = DateTimeUtils.getUnixTime(`${date} ${time}`, DateTimeUtils.DATETIME_FORMAT);
        const payload = {
            contact_id,
            direction,
            result: this.isFuture() ? 'upcoming' : result,
            notes,
            user_id,
            length,

            source: from,
            occurred,
            destination: to
        };

        this.props.logCall(payload).then(() => {
            Notification.alert('Successfully logged call!', STATUS_TYPES.SUCCESS, true);
            this.handleClose();
            if (this.props.refresh) {
                this.props.refresh();
            }
        }).catch(() => {
            Notification.alert('Failed to log call', STATUS_TYPES.ERROR, true);
        });
    }

    isFuture = () => {
        const { date, time } = this.state;
        return DateTimeUtils.isValid(date) && DateTimeUtils.isValid(time, DateTimeUtils.TIME_FORMAT) && !DateTimeUtils.isBeforeOrOnCurrentDate(`${date} ${time}`, DateTimeUtils.DATETIME_FORMAT)
    }

    render() {
        return (
            <Popup
                trigger={this.props.trigger}
                content={(
                    <CallActivityForm
                        assigned_user={this.state.assigned_user}
                        date={this.state.date}
                        time={this.state.time}
                        onChange={this.onChange}
                        onChangeDate={this.onChangeDate}
                        onChangeTime={this.onChangeTime}
                        direction={this.state.direction}
                        note={this.state.note}
                        numberOfHours={this.state.numberOfHours}
                        numberOfMinutes={this.state.numberOfMinutes}
                        result={this.state.result}
                        size='tiny'
                        onCancel={this.handleClose}
                        onAdd={this.onAdd}
                        isFuture={this.isFuture()}
                        user_id={this.props.assigned_user}
                        isLoggingCall={this.props.isLoggingCall}
                        isCalendarOpen={this.state.isCalendarOpen}
                        onCloseCalendar={this.onCloseCalendar}
                        onOpenCalendar={this.onOpenCalendar}
                        isTimeInputOpen={this.state.isTimeInputOpen}
                        onOpenTimeInput={this.onOpenTimeInput}
                        onCloseTimeInput={this.onCloseTimeInput}
                    />
                )}
                open={this.state.isOpen}
                on='click'
                onOpen={this.handleOpen}
                onClose={this.handleClose}
            />
        )
    }
}

const mapStateToProps = state => {
    const { first_name = '', last_name = '' } = state.users.userProfile;
    return ({
        isLoggingCall: state.self_report.isLoggingCall,
        from: `${first_name} ${last_name}`,
        assigned_user: state.auth.user_id
    });
};

const mapDispatchToProps = dispatch => ({
    logCall: (payload) => {
        return dispatch(selfReportActions.addCallActivity(payload));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(CallActivityFormContainer);
